<template>
  <div class="overflow-x-auto shadow-md rounded-lg">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <!-- Générer les entêtes dynamiquement ou définir des colonnes fixes -->
          <th
            v-for="key in displayKeys"
            :key="key"
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            {{ formatHeader(String(key)) }}
          </th>
          <th scope="col" class="relative px-6 py-3">
            <span class="sr-only">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr
          v-for="graffiti in graffitiList"
          :key="graffiti.idGraf"
          @click="emit('select-graffiti', graffiti.idGraf)"
          class="hover:bg-gray-50 cursor-pointer transition-colors duration-150"
        >
          <td
            v-for="key in displayKeys"
            :key="key"
            class="px-6 py-4 whitespace-nowrap text-sm text-gray-800"
          >
            <!-- Afficher la valeur, potentiellement avec formatage -->
            <span v-if="typeof graffiti[key] === 'boolean'">
              {{ graffiti[key] ? 'Oui' : 'Non' }}
            </span>
            <span v-else>
              {{ graffiti[key] ?? '-' }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <button
              @click="emit('select-graffiti', graffiti.idGraf)"
              class="text-primary hover:text-primary-dark"
            >
              Détails
            </button>
          </td>
        </tr>
        <tr v-if="graffitiList.length === 0">
          <td :colspan="displayKeys.length + 1" class="px-6 py-4 text-center text-gray-500">
            Aucun graffiti à afficher.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { GraffitiWithThemes } from '@/types'
import { computed } from 'vue'

const props = defineProps<{
  graffitiList: GraffitiWithThemes[]
}>()

const emit = defineEmits<{
  (e: 'select-graffiti', id: number): void
}>()

// Define which columns from Graffiti interface should be displayed
// We add 'themes' because it's added by the store transformation
const displayColumns: Array<keyof GraffitiWithThemes | 'themes'> = [
  'idBdc',
  'type',
  'categorie',
  'description',
  'datation',
  'technique',
  'langue',
  'inedit',
  'autopsie',
  // Add or remove keys from Graffiti interface here to control displayed columns
]

// Définir les clés à afficher dans le tableau
const displayKeys = computed(() => {
  if (props.graffitiList.length === 0) return []
  // Sélectionner et ordonner les colonnes pertinentes
  const preferredOrder: Array<keyof GraffitiWithThemes> = displayColumns
  const allKeys = Object.keys(props.graffitiList[0]) as Array<keyof GraffitiWithThemes>
  return preferredOrder.filter(key => allKeys.includes(key))
})

// Fonction pour formater les entêtes (simpliste)
const formatHeader = (key: string) => {
  // Remplacer les underscores, mettre en majuscule la première lettre
  return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}
</script>

<style scoped>
/* Styles spécifiques si nécessaire */
:root {
  --primary: #8b4513; /* Assurez-vous que c'est cohérent */
  --primary-dark: #654321;
}
.text-primary {
  color: var(--primary);
}
.hover\:text-primary-dark:hover {
  color: var(--primary-dark);
}
</style>
